import { render, staticRenderFns } from "./ApproveMemberModal.vue?vue&type=template&id=3ca0dea1&scoped=true"
import script from "./ApproveMemberModal.vue?vue&type=script&lang=js"
export * from "./ApproveMemberModal.vue?vue&type=script&lang=js"
import style0 from "./ApproveMemberModal.vue?vue&type=style&index=0&id=3ca0dea1&prod&scoped=true&lang=css"
import style1 from "./ApproveMemberModal.vue?vue&type=style&index=1&id=3ca0dea1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca0dea1",
  null
  
)

export default component.exports